import { createRenderTarget } from '../../render-target'
import { TheWestHeaderActionsWeb } from './TheWestHeaderActions.web'
import { TheWestHeaderActionsApp } from './TheWestHeaderActions.app'

export const TheWestHeaderActions = createRenderTarget('TheWestHeaderActions', {
    web: TheWestHeaderActionsWeb,
    amp: null,
    rss: null,
    preview: TheWestHeaderActionsWeb,
    app: TheWestHeaderActionsApp,
})
TheWestHeaderActions.displayName = 'TheWestHeaderActions'
